import { axiosInstance } from '@libs/axios/axios';
import { AvailableSlotsResult, DayAvailability, TimeSlot } from './entity';
import { apiCall } from '@shared/entity';
import { customerAxiosInstance } from '@libs/axios/customerAxiosInstance';

export const getAvailableSlots = async (
  date: string,
  serviceId: string,
): Promise<AvailableSlotsResult> =>
  apiCall(
    async () =>
      await axiosInstance.get(
        `/api/schedule/available-slots?date=${date}&serviceId=${encodeURIComponent(serviceId)}`,
      ),
    'api.visitSchedule.slotsError',
  ).then((res: AvailableSlotsResult) => res);

export const getHighlightedDays = async (
  month: string,
  serviceId: string,
): Promise<Record<string, DayAvailability>> =>
  apiCall(
    async () =>
      await axiosInstance.get(
        `/api/schedule/highlighted-days?month=${month}&serviceId=${encodeURIComponent(serviceId)}`,
      ),
    'api.visitSchedule.highlightedDaysError',
  ).then((res: { days: Record<string, DayAvailability> }) => res.days);

export const getCustomerAvailableSlots = async (
  date: string,
  serviceId: string,
): Promise<TimeSlot[]> =>
  apiCall(
    async () =>
      await customerAxiosInstance.get(
        `/api/customer-reservation/available-slots?date=${date}&serviceId=${encodeURIComponent(serviceId)}`,
      ),
    'api.visitSchedule.slotsError',
  ).then((res: { slots: TimeSlot[] }) => res.slots);
